import { EntityProfileType } from '@/types/enums/entity-profile-type.enum';

const ENTITY_PROFILE_TYPE_BY_ROOT: Record<string, EntityProfileType> = {
  profissionais: EntityProfileType.PROFESSIONAL,
  parceiros: EntityProfileType.PARTNER,
  laboratorios: EntityProfileType.LABORATORY,
};

export function getEntityProfileType(pathname: string | null | undefined): EntityProfileType | undefined {
  if (!pathname) {
    return undefined;
  }

  const segments = pathname.split('/').filter(Boolean);

  if (segments.length !== 2) {
    return undefined;
  }

  return ENTITY_PROFILE_TYPE_BY_ROOT[segments[0]];
}
